import BaseService from './BaseService';

class FormRuleAlertService extends BaseService{

}

export default new FormRuleAlertService('health_backend','health/form_rule_alerts');